export const FAILED = 'FAILED';
export const MISSED = 'MISSED';
export const PENDING = 'PENDING';
export const SUCCESS = 'SUCCESS';
export const SUSPENDED = 'SUSPENDED';
export const UNKNOWN = 'UNKNOWN';
